"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuidValidator = exports.urlValidator = exports.textValidator = void 0;

var textValidator = function textValidator(text) {
  var isValid = text.trim().length > 0;
  var message = isValid ? null : "Field must not be empty";
  return {
    isValid: isValid,
    message: message
  };
};

exports.textValidator = textValidator;

var urlValidator = function urlValidator(url) {
  var isValid = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?.*$/.test(url);
  var message = isValid ? null : "Field must be a valid URL";
  return {
    isValid: isValid,
    message: message
  };
};

exports.urlValidator = urlValidator;

var uuidValidator = function uuidValidator(id) {
  var uuidV4Regex = /^[A-F\d]{8}-[A-F\d]{4}-4[A-F\d]{3}-[89AB][A-F\d]{3}-[A-F\d]{12}$/i;
  return id.length > 0 && uuidV4Regex.test(id);
};

exports.uuidValidator = uuidValidator;

//# sourceMappingURL=validatorUtils.js.map